<template>
    <div class="md-layout">
        <div class="md-layout-item md-small-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>Activity</md-icon>
                    </div>
                    <h4 class="title">Add Vendor</h4>
                </md-card-header>

                <form @submit.prevent="add">
                    <md-card-content>
                        <div class="text-right">
                            <md-button @click="goBack" class="md-primary md-dense">
                                Back to List
                            </md-button>
                        </div>

                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Name
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="vendor.name"/>
                                    <validation-error :errors="apiValidationErrors.name"/>
                                </md-field>
                            </div>
                        </div>
                        <br>
                      <div class="md-layout">
                        <label class="md-layout-item md-size-25 md-form-label">
                          Short Name
                        </label>
                        <div class="md-layout-item">
                          <md-field class="md-invalid">
                            <md-input v-model="vendor.short_name"/>
                            <validation-error :errors="apiValidationErrors.short_name"/>
                          </md-field>
                        </div>
                      </div>
                      <br>
                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Description
                            </label>
                            <div class="md-layout-item">
                                <ckeditor
                                        :editor="editor"
                                        v-model="vendor.description"
                                        :config="editorConfig"
                                ></ckeditor>
                                <validation-error :errors="apiValidationErrors.description" />
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Address
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="vendor.address"/>
                                    <validation-error :errors="apiValidationErrors.address"/>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Phone Number
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="vendor.phone_number"/>
                                    <validation-error :errors="apiValidationErrors.phone_number"/>
                                </md-field>
                            </div>
                        </div>

                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Telephone Number
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="vendor.telephone_number"/>
                                    <validation-error :errors="apiValidationErrors.telephone_number"/>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Email
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="vendor.email"/>
                                    <validation-error :errors="apiValidationErrors.email"/>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Website
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="vendor.website"/>
                                    <validation-error :errors="apiValidationErrors.website"/>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Logo
                            </label>
                            <div class="md-layout-item">
                                <div class="file-input">
                                    <div v-if="image">
                                        <div class="image-container">
                                            <img :src="image" />
                                        </div>
                                    </div>
                                    <div class="image-container" v-else>
                                        <img :src="default_image" />
                                    </div>
                                    <div class="button-container">
                                        <md-button
                                                class="md-danger md-round"
                                                @click="removeImage"
                                                v-if="image"
                                               >
                                            <i class="fa fa-times" />
                                            Remove
                                        </md-button>
                                        <md-button class="md-success md-fileinput">
                                            <template v-if="!image">Select image</template>
                                            <template v-else>Change</template>
                                            <input type="file" @change="onFileChange" />
                                        </md-button>
                                    </div>
                                </div>
                                <md-field class="md-invalid">
                                    <validation-error :errors="apiValidationErrors.image" />
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Business Name
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="vendor.business_name"/>
                                    <validation-error :errors="apiValidationErrors.business_name"/>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Short Name
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="vendor.short_name"/>
                                    <validation-error :errors="apiValidationErrors.short_name"/>
                                </md-field>
                            </div>
                        </div>
                    </md-card-content>

                    <md-card-actions md-alignment="right">
                        <md-button type="submit" class="md-success">Add Vendor</md-button>
                    </md-card-actions>
                </form>
            </md-card>
        </div>
    </div>
</template>
<script>
import { ValidationError } from '@/components';
import formMixin from '@/mixins/form-mixin';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CKEditor from '@ckeditor/ckeditor5-vue';

export default {
    components: { ValidationError, ckeditor: CKEditor.component },

    mixins: [formMixin],

    data: () => ({
        editor: ClassicEditor,
        editorConfig: {
            toolbar: [
                'heading',
                '|',
                'bold',
                'italic',
                'link',
                'bulletedList',
                'numberedList',
                'blockQuote',
                'Outdent',
                'Indent',
                'TextColor',
                'BGColor',
            ],
        },
        vendor: {
            type: 'vendors',
            name: null,
            short_name: null,
            description: null,
            address: null,
            phone_number: null,
            telephone_number: null,
            email: null,
            website:null,
            logo: null,
            business_name:null
        },
        image: '',
        file: null,
        default_image: process.env.VUE_APP_BASE_URL + '/img/placeholder.jpg',
    }),
    created () {
    },
    methods: {
        async add () {
            try {
                await this.$store.dispatch('vendors/add', this.vendor);
                this.vendor = await this.$store.getters['vendors/vendor'];
                if (this.file) {
                    // upload image and get image url
                    await this.$store.dispatch('vendors/upload', {
                        item: this.vendor,
                        image: this.file,
                    });
                    this.vendor.logo = await this.$store.getters['vendors/url'];
                    // update item with image url
                    await this.$store.dispatch('vendors/update', this.vendor);
                    this.vendor = await this.$store.getters['vendors/vendor'];
                }
                this.notifySuccess('Vendor added successfully.');
                this.goBack();
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.notifyError(e.response.data.errors[0].title);
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.notifyError('Oops, something went wrong!');
                }
            }
        },
        onFileChange (e) {
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length) {
                return;
            }
            this.createImage(files[0]);
        },

        createImage (file) {
            let reader = new FileReader();
            reader.onload = (e) => {
                this.image = e.target.result;
                this.file = file;
            };
            reader.readAsDataURL(file);
        },

        removeImage () {
            this.image = null;
        },

        goBack () {
            this.$router.push({ name: 'Vendors List' });
        },
    },
};
</script>
<style lang="scss" scoped>
    .spacing {
        padding-bottom: 1rem;
    }

    .md-checkbox,
    .md-radio {
        margin-top: 15px;
        margin-bottom: 0.5rem;
    }

    .md-checkbox,
    .md-radio {
        display: flex;
    }

    .md-radio .md-radio-container {
        margin-left: 5px;
        position: relative;
        left: -3px;
    }

    .md-form-label + .md-layout-item .md-checkbox:not(:first-child),
    .md-form-label + .md-layout-item + .md-layout-item .md-radio:not(:first-child),
    .md-form-label + .md-layout-item .md-radio {
        margin-top: 0;
    }

    .md-field.md-has-textarea:not(.md-autogrow) .md-textarea {
        padding-left: 0;
        padding-top: 10px;
        min-height: 150px;
    }

    .md-field:after,
    .md-field:before {
        bottom: 10px !important;
    }
    .ck-editor__editable {
        min-height: 200px;
        width: auto;
    }
</style>
